import { render, staticRenderFns } from "./EventsValidationDialog.vue?vue&type=template&id=4039d3b1"
import script from "./EventsValidationDialog.vue?vue&type=script&lang=ts"
export * from "./EventsValidationDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports